export const alertTypes = {
  FETCH_REQUEST: "ALERT_FETCH_REQUEST",
  FETCH_SUCCESS: "ALERT_FETCH_SUCCESS",
  UPDATE_FILTERS: "ALERT_UPDATE_FILTERS",
  UPDATE_UI: "ALERT_UPDATE_UI",
  FETCH_FAILURE: "ALERT_FETCH_FAILURE",
  ALERT_COUNT_SUCCESS: "ALERT_ALERT_COUNT_SUCCESS",
  ALERT_STATUS_COUNT_SUCCESS: "ALERT_ALERT_STATUS_COUNT_SUCCESS",
  BULK_UPDATE_FILTER_FIELD: "ALERT_BULK_UPDATE_FILTER_FIELD",
  BULK_UPDATE_FIELD: "ALERT_BULK_UPDATE_FIELD",
  BULK_UPDATE_FILTER_BACK: "ALERT_BULK_UPDATE_FILTER_BACK",
  BULK_UPDATE_FILTER: "ALERT_BULK_UPDATE_FILTER",
  BULK_UPDATE_FILTER_SUCCESS: "ALERT_BULK_UPDATE_FILTER_SUCCESS",
  BULK_UPDATE_FILTER_FAILURE: "ALERT_BULK_UPDATE_FILTER_FAILURE",
  BULK_UPDATE_SUBMIT: "ALERT_BULK_UPDATE_SUBMIT",
  BULK_UPDATE_RESPONSE: "ALERT_BULK_UPDATE_RESPONSE",
  SINGLE_UPDATE_REQUEST: "ALERT_SINGLE_UPDATE_REQUEST",
  SINGLE_UPDATE_SUBMIT: "ALERT_SINGLE_UPDATE_SUBMIT",
  SINGLE_UPDATE_FIELD: "ALERT_SINGLE_UPDATE_FIELD",
  SINGLE_UPDATE_RESPONSE: "ALERT_SINGLE_UPDATE_RESPONSE",
  DOWNLOAD_REQUEST: "ALERT_DOWNLOAD_REQUEST",
  DOWNLOAD_SUCCESS: "ALERT_DOWNLOAD_SUCCESS",
  DOWNLOAD_FAILURE: "ALERT_DOWNLOAD_FAILURE",
  RESET_BULK_UPDATE_FORM: "ALERT_RESET_BULK_UPDATE_FORM",
  UPDATE_PAGINATION_REQUEST: "ALERT_UPDATE_PAGINATION_REQUEST",
};

export const fetchRequest = (filter) => ({
  type: alertTypes.FETCH_REQUEST,
  payload: filter,
});

export const fetchSuccess = (resp) => ({
  type: alertTypes.FETCH_SUCCESS,
  payload: resp,
});
export const updateUI = (req) => ({
  type: alertTypes.UPDATE_UI,
  payload: req,
});
export const updateFilters = (resp) => ({
  type: alertTypes.UPDATE_FILTERS,
  payload: resp,
});

export const alertAlertCountSuccess = (resp) => ({
  type: alertTypes.ALERT_COUNT_SUCCESS,
  payload: resp,
});

export const alertAlertStatusCountSuccess = (resp) => ({
  type: alertTypes.ALERT_STATUS_COUNT_SUCCESS,
  payload: resp,
});

export const fetchFailure = (resp) => ({
  type: alertTypes.FETCH_FAILURE,
  payload: resp,
});

export const bulkUpdateFilterField = (field) => ({
  type: alertTypes.BULK_UPDATE_FILTER_FIELD,
  payload: field,
});

export const bulkUpdateField = (filter) => ({
  type: alertTypes.BULK_UPDATE_FIELD,
  payload: filter,
});

export const bulkUpdateFilter = (filter) => ({
  type: alertTypes.BULK_UPDATE_FILTER,
  payload: filter,
});

export const bulkUpdateFilterBack = () => ({
  type: alertTypes.BULK_UPDATE_FILTER_BACK,
});
 export const updatePaginationRequest = (req) => ({
      type: alertTypes.UPDATE_PAGINATION_REQUEST,
      payload: req
  });

export const bulkUpdateFilterSuccess = (count) => ({
  type: alertTypes.BULK_UPDATE_FILTER_SUCCESS,
  payload: count,
});

export const bulkUpdateFilterFailure = () => ({
  type: alertTypes.BULK_UPDATE_FILTER_FAILURE,
});

export const bulkUpdateSubmit = (data) => ({
  type: alertTypes.BULK_UPDATE_SUBMIT,
  payload: data,
});

export const bulkUpdateResponse = (resp) => ({
  type: alertTypes.BULK_UPDATE_RESPONSE,
  payload: resp,
});

export const singleUpdateRequest = (filter) => ({
  type: alertTypes.SINGLE_UPDATE_REQUEST,
  payload: filter,
});

export const singleUpdateField = (filter) => ({
  type: alertTypes.SINGLE_UPDATE_FIELD,
  payload: filter,
});

export const singleUpdateSubmit = () => ({
  type: alertTypes.SINGLE_UPDATE_SUBMIT,
});

export const singleUpdateResponse = (resp) => ({
  type: alertTypes.SINGLE_UPDATE_RESPONSE,
  payload: resp,
});

export const downloadRequest = (total) => ({
  type: alertTypes.DOWNLOAD_REQUEST,
  payload: total,
});

export const downloadSuccess = (resp) => ({
  type: alertTypes.DOWNLOAD_SUCCESS,
  payload: resp,
});

export const downloadFailure = (error) => ({
  type: alertTypes.DOWNLOAD_FAILURE,
  payload: error,
});

export const resetBulkUpdateForm = () => ({
  type: alertTypes.RESET_BULK_UPDATE_FORM,
});
